export type FEED_TAB_OPTION_KEYS = 'ALL' | 'HOLDR' | 'SOCIAL' | 'NEWS';
export type PROFILE_TAB_OPTION_KEYS =
  | 'FEEDS'
  | 'ARTICLES'
  | 'DETAILS'
  | 'COLLECTIONS';
export type EVENT_TAB_OPTION_KEYS =
  | 'THIS_WEEK'
  | 'THIS_MONTH'
  | 'COMING_SOON'
  | 'ALL';
export type CHANNELS_TAB_OPTION_KEYS = 'RECOMMENDED' | 'TRENDING' | 'JOINED';
export type SUBSCRPTIONS_TAB_OPTION_KEYS = 'TRACKING' | 'LIVE' | 'RECOMMENDED';
export type DISCOVER_TAB_OPTION_KEYS = 'RECOMMENDED' | 'TRENDING';
export type MEMBERS_TAB_OPTIONS_KEYS = 'ONLINE' | 'OFFLINE';

type FEEDS_TAB_OPTIONS_MAP = { [key in FEED_TAB_OPTION_KEYS]: string };
type PROFILE_TAB_OPTIONS_MAP = { [key in PROFILE_TAB_OPTION_KEYS]: string };
type EVENT_TAB_OPTIONS_MAP = { [key in EVENT_TAB_OPTION_KEYS]: string };
type CHANNELS_TAB_OPTIONS_MAP = { [key in CHANNELS_TAB_OPTION_KEYS]: string };
type SUBSCRIPTIONS_TAB_OPTIONS_MAP = {
  [key in SUBSCRPTIONS_TAB_OPTION_KEYS]: string;
};
type DISCOVER_TAB_OPTIONS_MAP = { [key in DISCOVER_TAB_OPTION_KEYS]: string };
type MEMBERS_TAB_OPTIONS_MAP = { [key in MEMBERS_TAB_OPTIONS_KEYS]: string };

/**
 * Change order of object to change order of render
 */

export const FEEDS_TAB_OPTIONS: FEEDS_TAB_OPTIONS_MAP = {
  ALL: 'all',
  HOLDR: 'holdr',
  NEWS: 'news',
  SOCIAL: 'socials',
};

export const PROFILE_TAB_OPTIONS: PROFILE_TAB_OPTIONS_MAP = {
  DETAILS: 'details',
  FEEDS: 'feeds',
  ARTICLES: 'articles',
  COLLECTIONS: 'collections',
};

export const EVENT_TAB_OPTIONS: EVENT_TAB_OPTIONS_MAP = {
  THIS_WEEK: 'this week',
  THIS_MONTH: 'this month',
  COMING_SOON: 'coming soon',
  ALL: 'all events',
};

export const RELEASES_TAB_OPTIONS: EVENT_TAB_OPTIONS_MAP = {
  THIS_WEEK: 'this week',
  THIS_MONTH: 'this month',
  COMING_SOON: 'coming soon',
  ALL: 'all releasess',
};

export const CHANNELS_TAB_OPTIONS: CHANNELS_TAB_OPTIONS_MAP = {
  JOINED: 'your channels',
  TRENDING: 'trending',
  RECOMMENDED: 'recommended',
};

export const SUBSCRIPTIONS_TAB_OPTIONS: SUBSCRIPTIONS_TAB_OPTIONS_MAP = {
  TRACKING: 'tracking',
  LIVE: 'live',
  RECOMMENDED: 'recommended',
};

export const DISCOVER_TAB_OPTIONS: DISCOVER_TAB_OPTIONS_MAP = {
  RECOMMENDED: 'recommended',
  TRENDING: 'trending',
};

export const MEMBERS_TAB_OPTIONS: MEMBERS_TAB_OPTIONS_MAP = {
  ONLINE: 'online',
  OFFLINE: 'offline',
};
